import { render, staticRenderFns } from "./wxxiangqing.vue?vue&type=template&id=1478494e"
import script from "./wxxiangqing.vue?vue&type=script&lang=js"
export * from "./wxxiangqing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports